// Slow editorial marquee — Playfair text separated by gold diamonds.
const PHRASES = [
    "Plan for what happens after",
    "Start at $88",
    "A relationship that lasts generations",
    "Quiet conviction",
    "The default way families finally get this done",
];

function Row() {
    return (
        <div className="flex shrink-0 items-center">
            {PHRASES.map((p, i) => (
                <div key={i} className="flex items-center">
                    <span className="font-display text-2xl md:text-4xl font-light italic text-white/30 whitespace-nowrap px-8">
                        {p}
                    </span>
                    <span className="text-gold/70 text-xs rotate-45">◆</span>
                </div>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            className="relative overflow-hidden border-y border-white/10 py-8 bg-navy-900"
            data-testid="marquee"
        >
            <div className="flex w-max animate-marquee">
                <Row />
                <Row />
            </div>
            {/* edge fades */}
            <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-navy-900 to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-navy-900 to-transparent" />
        </div>
    );
}
